export default function registerServiceWorker(serviceWorkerName) {
    let swUrl = `${process.env.PUBLIC_URL}/${serviceWorkerName}.js`;
    navigator?.serviceWorker?.register(swUrl);
}
